(function(){
  var side=document.querySelector('.sx-side');
  var burger=document.querySelector('[data-sx-burger]');
  if(side&&burger){
    burger.addEventListener('click',function(){
      var open=side.classList.toggle('is-open');
      burger.setAttribute('aria-expanded',open?'true':'false');
    });
  }
  var calc=document.querySelector('[data-sx-calc]');
  if(calc){
    var f=function(n){return (Math.round(n*100)/100).toLocaleString('fr-FR',{maximumFractionDigits:2})};
    var run=function(){
      var b=parseFloat(calc.querySelector('[name=buy]').value)||0;
      var s=parseFloat(calc.querySelector('[name=sell]').value)||0;
      var u=parseFloat(calc.querySelector('[name=units]').value)||0;
      var m=Math.max(0,s-b);
      calc.querySelector('[data-out=unit]').textContent=f(m)+' €';
      calc.querySelector('[data-out=month]').textContent=f(m*u)+' €';
      calc.querySelector('[data-out=rate]').textContent=s>0?Math.round(m/s*100)+' %':'–';
    };
    calc.addEventListener('input',run);run();
  }
  if(document.querySelector('[data-sx-request-sent]')){
    fetch('/cart/clear.js',{method:'POST',headers:{'Content-Type':'application/json'}}).then(function(){
      document.querySelectorAll('[data-sx-cartlist]').forEach(function(el){el.hidden=true});
      document.querySelectorAll('[data-sx-cartcount]').forEach(function(el){el.textContent='0'});
    });
  }
})();